import angular from 'angular';

import { Configuration } from './config';
import { FileDownload } from './directives/file-download.directive';
import { NgReallyClick } from './directives/ng-really-click.directive';
import { PasswordVerify } from './directives/password-verify.directive';
import { CalendarService } from './services/calendar.service';

const commons = angular.module('commons', []);

commons.config(Configuration);

commons.directive('fileDownload', FileDownload);
commons.directive('ngReallyClick', NgReallyClick);
commons.directive('passwordVerify', PasswordVerify)

commons.service('CalendarService', CalendarService);

String.prototype.capitalize = function () {
  return this.replace(/^./, function (match) {
    return match.toUpperCase();
  });
};

export const CommonsModule = commons;